import { render, staticRenderFns } from "./ComunicacionesAmbientales.vue?vue&type=template&id=7368eebc&"
import script from "./ComunicacionesAmbientales.vue?vue&type=script&lang=js&"
export * from "./ComunicacionesAmbientales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports